import { render } from "./NaoEncontrada.vue?vue&type=template&id=2afb7bfc"
import script from "./NaoEncontrada.vue?vue&type=script&lang=js"
export * from "./NaoEncontrada.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__